import { GET_DIVISIONS, SET_DIVISIONS } from "./DivisionsType";

const getDivisions = () => ({
    type: GET_DIVISIONS,
});

const setDivisions = (divisionsDropDownList: any) => ({
    type: SET_DIVISIONS,
    divisionsDropDownList: divisionsDropDownList
});

export {
    getDivisions,
    setDivisions
}
